import { useRequiredContext } from "@redotech/react-util/context";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ExecutionTreeView } from "../components/timeline/events/rules-triggered/execution-tree-view";

export const RuleExecutionView = memo(function RuleExecutionView() {
  const { conversationId, workflowId } = useParams<{
    conversationId: string;
    workflowId: string;
  }>();
  const navigate = useNavigate();
  const team = useRequiredContext(TeamContext);

  const handleClose = useCallback(() => {
    navigate(`/stores/${team._id}/support-v2/${conversationId}`);
  }, [navigate, team._id, conversationId]);

  if (!workflowId) {
    return (
      <Flex align="center" flex={1} justify="center">
        <Text textColor="tertiary">No workflow ID provided</Text>
      </Flex>
    );
  }

  return (
    <Flex flex={1} overflow="hidden" style={{ height: "100%" }}>
      <ExecutionTreeView onClose={handleClose} workflowId={workflowId} />
    </Flex>
  );
});
